import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import { each } from 'lodash'

import { callApi } from '../services/fetchService'

import DataTable from '../components/DataTable'
import FaIcon from '../components/FaIcon'
import { Button, message } from 'antd'
import TableButton from '../components/TableButton'



class Doctors extends Component {

    state = {
        data: [],
        loading: false
    }

    static propTypes = {
        comboboxes: PropTypes.object.isRequired,
        session: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }

    fetch = (params = {}) => {
        const { intl, comboboxes } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'doctors'
        }).then((data) => {
            this.setState({
                data: each(data, (item) => {
                    item.fullName = item.lastName + ' ' + item.firstName
                    item.addressCountry = comboboxes.byKey.country[item.addressCountry].value
                }),
                loading: false
            })
        }).catch((err) => {
            message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    block = (doctor) => {
        const { intl } = this.props
        callApi({
            endpoint: 'users/' + doctor.id + '/block',
            method: 'POST'
        }).then((data) => {
            message.success(intl.formatMessage({ id: 'doctors.blocked' }))
            this.fetch();
        }).catch((data) => {
            if (data.code === 8) {
                message.warn(intl.formatMessage({ id: 'doctors.unableToSelfBlock' }))
            } else {
                message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            }
        })
    }

    unblock = (doctor) => {
        const { intl } = this.props
        callApi({
            endpoint: 'users/' + doctor.id + '/unblock',
            method: 'POST'
        }).then((data) => {
            message.success(intl.formatMessage({ id: 'doctors.unblocked' }))
            this.fetch();
        }).catch((data) => {
            if (data.code === 9) {
                message.warn(intl.formatMessage({ id: 'doctors.unableToSelfUnblock' }))
            } else {
                message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            }
        })
    }

    blockAddConsultations = (doctor) => {
        const { intl } = this.props
        callApi({
            endpoint: 'users/' + doctor.id + '/blockAddConsultations',
            method: 'POST'
        }).then((data) => {
            message.success(intl.formatMessage({ id: 'doctors.blocked' }))
            this.fetch();
        }).catch((data) => {
            if (data.code === 8) {
                message.warn(intl.formatMessage({ id: 'doctors.unableToSelfBlock' }))
            } else {
                message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            }
        })
    }

    unblockAddConsultations = (doctor) => {
        const { intl } = this.props
        callApi({
            endpoint: 'users/' + doctor.id + '/unblockAddConsultations',
            method: 'POST'
        }).then((data) => {
            message.success(intl.formatMessage({ id: 'doctors.unblocked' }))
            this.fetch();
        }).catch((data) => {
            if (data.code === 9) {
                message.warn(intl.formatMessage({ id: 'doctors.unableToSelfUnblock' }))
            } else {
                message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            }
        })
    }

    rowsConfig = (record) => ({
        style: { cursor: 'pointer' },
        onClick: (e) => {
            if (this.props.session.user.id === record.id) {
                this.props.history.push('/profile')
            } else {
                this.props.history.push('/doctor/' + record.id)
            }
        }
    })

    render() {
        const { data, loading } = this.state

        const columns = [
            { title: "doctors.nameColumn", dataIndex: "fullName", type: "string", sorter: true },
            { title: "doctors.lastConsultationColumn", dataIndex: "lastConsultation", type: "date", sorter: true },
            { title: "doctors.numberOfPatientsColumn", dataIndex: "numberOfPatients", type: "number", sorter: true },
            { title: "doctors.numberOfConsultationsColumn", dataIndex: "numberOfConsultations", type: "number", sorter: true },
            { title: "doctors.numberOfBloodTestsColumn", dataIndex: "numberOfBloodTests", type: "number", sorter: true },
            { title: "doctors.countryColumn", dataIndex: "addressCountry", type: "string", sorter: true },
            { title: "doctors.activeColumn", dataIndex: "blocked", type: "boolean", inverted: true },
            {
                title: "misc.actions", width: "100px", key: "action", render: (record) =>
                    <span>
                        {record.blocked ?
                            <TableButton color="green" icon="user-unlock" onClick={this.unblock} value={record} confirm tip={<FormattedMessage id="doctors.unblockTooltip" />} />
                            : <TableButton color="red" icon="user-lock" onClick={this.block} value={record} confirm tip={<FormattedMessage id="doctors.blockTooltip" />} />
                        }
                        {record.canAddConsultations ?
                            <TableButton color="red" icon="lock-alt" onClick={this.blockAddConsultations} value={record} confirm tip={<FormattedMessage id="doctors.blockAddConsultationsTooltip" />} />
                            : <TableButton color="green" icon="unlock-alt" onClick={this.unblockAddConsultations} value={record} confirm tip={<FormattedMessage id="doctors.unblockAddConsultationsTooltip" />} />
                        }
                    </span>
            }
        ]

        return (
            <div>
                <h1><FaIcon icon="user-md" fixedWidth /> <FormattedMessage id="doctors.title" /></h1>
                <div className="action-bar"><Link to="/users"><Button><FaIcon icon="users" /> <FormattedMessage id="doctors.allUsers" /></Button></Link></div>
                <DataTable columns={columns} dataSource={data} loading={loading} rowKey="id" size="middle" onRow={this.rowsConfig} />
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    comboboxes: state.comboboxes,
    session: state.session
})

export default withRouter(injectIntl(connect(mapStateToProps)(Doctors)))


// WEBPACK FOOTER //
// ./src/views/Doctors.js